"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useMemo } from "react";
const getRatingColorClass = (rating: number): string => {
  if (rating > 0) {
    return "tw-text-green";
  }
  if (rating < 0) {
    return "tw-text-red";
  }
  return "tw-text-iron-400";
};
export default function UserProfileTooltipTopRep(t0) {
  const $ = _c(8);
  const {
    repRates
  } = t0;
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    bb0: {
      const ratingStats = repRates?.rating_stats ?? [];
      if (ratingStats.length === 0) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = [];
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
        break bb0;
      }
      t1 = [...ratingStats].sort(_temp).slice(0, 3);
    }
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const topRepCategories = t1;
  if (topRepCategories.length === 0) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mb-2 tw-text-[0.6875rem] tw-font-semibold tw-uppercase tw-leading-4 tw-tracking-wider tw-text-iron-500">Top Rep</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== topRepCategories) {
    t3 = topRepCategories.map(_temp2);
    $[4] = topRepCategories;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="tw-mt-4">{t2}<div className="tw-flex tw-flex-wrap tw-gap-2">{t3}</div></div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp2(rep) {
  return <div key={rep.category} className="tw-group tw-inline-flex tw-min-w-0 tw-items-center tw-gap-x-2 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-[#18191B] tw-px-2 tw-py-1.5 tw-transition-all tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-white/20 desktop-hover:hover:tw-bg-white/10"><span className="tw-max-w-[132px] tw-truncate tw-text-xs tw-font-medium tw-text-white">{rep.category}</span><span className={`tw-whitespace-nowrap tw-text-xs tw-font-medium tw-transition-colors ${getRatingColorClass(rep.rating)}`}>{formatNumberWithCommas(rep.rating)}</span></div>;
}
function _temp(a, b) {
  return b.rating - a.rating || b.contributor_count - a.contributor_count;
}